import { Move } from "assets/icons/Common";
import { useEffect, useState } from "react";
import { getIframeTemplate } from "util/iframeUtils";

import { MoveIconBtn, VideoContainer } from "../embed.styles";

interface EmbedVideoProps {
  value?: string;
  onToggleFocus: (isFocus: boolean) => void;
  widgetId: string;
}

export const EmbedVideo = (props: EmbedVideoProps) => {
  const { value = "", onToggleFocus, widgetId } = props;
  const [iframe, setIframe] = useState("");

  useEffect(() => {
    setIframe(getIframeTemplate(value));
  }, [value]);

  const handleBlur = () => {
    if (document.activeElement?.parentElement?.id === widgetId) {
      onToggleFocus(true);
    }
  };

  useEffect(() => {
    window.addEventListener("blur", handleBlur);

    return () => {
      window.removeEventListener("blur", handleBlur);
    };
  });

  return (
    <VideoContainer>
      <div id={widgetId} dangerouslySetInnerHTML={{ __html: iframe }} />

      <MoveIconBtn Icon={Move} />
    </VideoContainer>
  );
};
